import { Component, inject } from '@angular/core';
import { PageNavigationService } from '../../../service/app-state/page-navigation.service';
import { TooltipDirective } from '@vydaps/gui-commons';

@Component({
  selector: 'ct-extraction-footer',
  templateUrl: './footer.component.html',
  imports: [TooltipDirective],
})
export class FooterComponent {
  protected readonly pageNavigationService = inject(PageNavigationService);
}
